import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩国免费漫画在线阅读`}
          title={`${comic.title} - 韩国免费漫画_漫画之家`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
          <span className="text-white text-sm font-medium bg-primary-500/90 px-4 py-1.5 rounded-full whitespace-nowrap">
            点击阅读
          </span>
        </div>
        {comic.isHot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            热门
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            新作
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 right-2 bg-foreground-900/70 text-white text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            已完结
          </span>
        )}
        {comic.featured && (
          <div className="absolute bottom-3 left-3 flex items-center gap-1 text-white text-xs">
            <i className="ri-star-fill text-amber-400"></i>
            <span>{comic.rating}</span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
          {comic.author} · {comic.updateDate}
        </p>
      </div>
    </Link>
  );
}